import { render, staticRenderFns } from "./public-holidays.vue?vue&type=template&id=79b5234e"
import script from "./public-holidays.vue?vue&type=script&lang=js"
export * from "./public-holidays.vue?vue&type=script&lang=js"
import style0 from "./public-holidays.vue?vue&type=style&index=0&id=79b5234e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports